import React from 'react';
import { DataGridButton, IColumnType, IDataType, SisDataGridColumns } from '../../components/table';
import {
  CustomerProjectBillingStatusTranslation,
  CustomerProjectTypeTranslation,
} from '../../types/customerProject.types';
import { getColorClass } from '../../types/userColor.types';
import { TimeSpanCellSortValue, TimeSpanDecimalCell } from '../Tasks/Columns';

export const Columns = (handleEdit, translate): SisDataGridColumns => [
  {
    dataType: IDataType.number,
    dataField: 'id',
    width: '5%',
    caption: 'Id',
  },
  {
    dataType: IDataType.string,
    dataField: 'customerName',
    width: '25%',
    caption: 'Customer name',
  },
  {
    dataType: IDataType.string,
    dataField: 'name',
    width: '35%',
    caption: 'Project name',
    cellRender: (row) => {
      const colorClass = getColorClass(row.data.color);
      return (
        <div className={`dropdown-user-color ${colorClass}`}>
          <span className="text">{row.data.name}</span>
        </div>
      );
    },
  },
  {
    dataType: IDataType.string,
    dataField: 'type',
    width: '15%',
    caption: 'Type',
    cellRender: (cellData: any) => {
      if (cellData.data.type)
        return (
          <>
            {translate!(
              CustomerProjectTypeTranslation[cellData.data.type],
              `CustomersProjects.Type`,
            )}
          </>
        );

      return <></>;
    },
    calculateCellValue: (data: any) => {
      if (data.type)
        return translate!(CustomerProjectTypeTranslation[data.type], `CustomersProjects.Type`);

      return undefined;
    },
  },
  {
    dataType: IDataType.string,
    dataField: 'projectStatusName',
    width: '15%',
    caption: 'Project status',
    cellRender: (row) => {
      const colorClass = getColorClass(row.data.projectStatusColor);
      return (
        <div className={`dropdown-user-color ${colorClass}`}>
          <span className="text">{row.data.projectStatusName}</span>
        </div>
      );
    },
  },
  {
    dataType: IDataType.string,
    dataField: 'defaultBillingStatus',
    width: '15%',
    caption: 'Billing status',
    cellRender: (cellData: any) => {
      if (cellData.data.defaultBillingStatus)
        return (
          <>
            {translate!(
              CustomerProjectBillingStatusTranslation[cellData.data.defaultBillingStatus],
              `CustomersProjects.Status`,
            )}
          </>
        );

      return <></>;
    },
    calculateCellValue: (data: any) => {
      if (data.defaultBillingStatus)
        return translate!(
          CustomerProjectBillingStatusTranslation[data.defaultBillingStatus],
          `CustomersProjects.Status`,
        );

      return undefined;
    },
  },
  {
    dataField: 'responsibleInternalName',
    width: '15%',
    caption: 'Responsible internal',
  },
    {
    dataField: 'assetName',
    width: '15%',
    caption: 'Asset',
  },
  {
    dataType: IDataType.date,
    dataField: 'goLiveDate',
    width: '15%',
    caption: 'Go live date',
  },
  {
    dataField: 'plannedTimeBudget',
    width: '80px',
    caption: 'Planned time budget',
    cssClass: 'dg-align-right',
    cellRender: TimeSpanDecimalCell,
    calculateSortValue: function (rowData) {
      return TimeSpanCellSortValue(rowData, 'plannedTimeBudget');
    },
    calculateCellValue: (rowData) => {
      const minutes = TimeSpanCellSortValue(rowData, 'plannedTimeBudget');
      return +(minutes / 60); // desetinné číslo
    },
  },
  {
    dataField: 'totalElapsedTime',
    width: '80px',
    caption: 'Total elapsed time',
    cssClass: 'dg-align-right',
    cellRender: TimeSpanDecimalCell,
    calculateSortValue: function (rowData) {
      return TimeSpanCellSortValue(rowData, 'totalElapsedTime');
    },
    calculateCellValue: (rowData) => {
      const minutes = TimeSpanCellSortValue(rowData, 'totalElapsedTime');
      return +(minutes / 60); // desetinné číslo
    },
  },
  {
    dataField: 'projectStatusIsActive',
    dataType: IDataType.boolean,
    caption: 'Is active',
    width: '7%',
  },
  {
    dataField: 'visible',
    dataType: IDataType.boolean,
    caption: 'Visible',
    width: '7%',
  },
  {
    type: IColumnType.buttons,
    cellRender: (data) => ButtonCell(data, handleEdit, translate),
    width: '8%',
  },
];

const ButtonCell = (cellData, handleEdit, translate) => {
  return (
    <DataGridButton
      hint={translate!('Edit', '')}
      icon="edit"
      cellData={cellData}
      onClick={() => handleEdit(cellData)}
    />
  );
};
